
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PATHS } from '@/routes/routePaths';

const AuthenticationRequired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <Card className="w-full max-w-lg shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Authentication Required</CardTitle>
          <CardDescription>Please sign in to access subscription management.</CardDescription>
        </CardHeader>
        <CardFooter className="justify-center">
          <Button onClick={() => navigate(PATHS.AUTH)} className="bg-orange-500 hover:bg-orange-600">
            Sign In
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AuthenticationRequired;
